import { useMemo } from 'react'

import { useGetWebhookTypes } from './use-get-webhooks-types'

export function useWebhookEventDescription(paymentProfileId: string | undefined) {
  const { data: types, isLoading } = useGetWebhookTypes(paymentProfileId)

  const typeToDescription = useMemo(() => {
    if (!types) return {}

    return Object.values(types).reduce<Record<string, string>>((acc, categoryTypes) => {
      categoryTypes.forEach(({ type, description }) => {
        acc[type] = description
      })
      return acc
    }, {})
  }, [types])

  const getEventDescription = (eventType: string | undefined): string => {
    if (!eventType) return ''
    return typeToDescription[eventType] ?? ''
  }

  return { getEventDescription, isLoading }
}
